import React from "react";
import { setSeenGizReveal } from "../utils/stars";
import Confetti from "react-confetti";

export default function StarGazerGizModal({ open, onClose, onGoToFinal }) {
  if (!open) return null;
  const [w, h] = [window.innerWidth, window.innerHeight];

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)",
      display: "grid", placeItems: "center", zIndex: 3000
    }}>
      <Confetti width={w} height={h} numberOfPieces={220} />
      <div style={{
        background: "#fff", borderRadius: 16, padding: 24,
        width: "min(92vw, 560px)", textAlign: "center",
        boxShadow: "0 14px 36px rgba(0,0,0,0.28)"
      }}>
        <h2 style={{ margin: 0 }}>Giz the Star‑Gazer ✨</h2>
        <p style={{ marginTop: 10 }}>
          “I’ve studied your 8 golden stars… Their pattern reveals the
          <b> ancient song</b> that can defeat Doron: <b>Für Elise</b>!
          Play it to turn Doron into stone.”
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 10 }}>
          <button onClick={() => { setSeenGizReveal(); onClose?.(); }}
                  style={{ padding: "10px 14px", borderRadius: 10, border: "1px solid #ddd", background: "#fafafa" }}>
            Not yet
          </button>
          <button onClick={() => { setSeenGizReveal(); onGoToFinal?.(); }}
                  style={{ padding: "10px 14px", borderRadius: 10, border: "none", background: "#111", color: "#fff" }}>
            Go to Final Battle
          </button>
        </div>
      </div>
    </div>
  );
}
